<!--
    描述： 造价文件中 新增概算价 模块
    时间： 2020/5/20
    created by zjj
-->
<template>
	<div class="estimate-price-layout">
		<!-- 主体 -->
		<div class="estimate-price-left"
			 :style="activeStyle">
			<!-- 基本信息 -->
			<basisPrice @changeShow="changeLeftShow"
						:projectId="curProjectId"></basisPrice>
			<!--项目结构-->
			<structureList ref="structureList"
						   :isBack="true"
						   :projectId="curProjectId"
						   costFiles="costFiles"
						   @onSuccess="onRefresh"
						   v-show="leftShow"></structureList>
			<!--其他费用-->
			<other-cost ref="otherCost"
						:projectId="curProjectId"
						:listData="otherCostData"
						@appendChild="appendChild"
						@removeNode="removeNode"
						v-show="leftShow"></other-cost>
			<!-- 预备费 -->
			<prepare-cost ref="prepareCost"
						  :projectId="curProjectId"
						  :listData="prepareCostData"
						  @appendChild="appendChild"
						  @removeNode="removeNode"
						  v-show="leftShow"></prepare-cost>
		</div>
		<!-- 右侧表格 -->
		<div class="estimate-price-right">
			<div class="baseList-layout">
				<div class="baseList-header">
					<div class="btnGroups">
						<el-button size="small"
								   type="warning"
								   @click="doBack">返回造价文件列表</el-button>
						<el-button size="small"
								   type="primary"
								   @click="changeLock">{{ isLock ? '解锁' : '锁定' }}</el-button>
						<el-button size="small"
								   type="success"
								   @click="doSave">保存</el-button>
					</div>
				</div>
				<!-- 表格主体 -->
				<div class="baseList-content">
					<estimate-table ref="rightTable"
									:mainCost="mainCost"
									:otherCost="otherCostData"
									:prepareCost="prepareCostData"
									@onSuccess="onSuccess"
									@changeVal="changeVal"></estimate-table>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import basisPrice from '../../basic-template/baseprice' // 基本信息
import structureList from '../project-info/components/left_structure' //项目结构
import otherCost from './components/other-cost'
import prepareCost from './components/prepare-cost' // 预备费
import estimateTable from './components/estimate-table' // 概算表格
import {
	getProjectBudgets,
	selectBudgetOtherList,
	deleteOtherCost
} from '@/api/modules/project_costfiles'
export default {
	name: 'estimate-price-index',
	components: {
		otherCost,
		structureList,
		prepareCost,
		basisPrice,
		estimateTable
	},
	data() {
		return {
			dialogObj: {
				// 弹窗对象
				title: '新增文件',
				visible: false,
				width: '650px',
				type: 'add'
			},
			projectId: '', //项目id
			btnLoading: false,
			isLock: true, // 是否锁定
			leftShow: true, // 左侧是否展示
			// 主要费用
			mainCost: [],
			// 其他费用
			otherCostData: [
				{
					uid: 'S001',
					sname: '其他费用',
					levelType: 0,
					moneyOther: 0,
					costPrice: 0,
					children: []
				}
			],
			// 预备费
			prepareCostData: [
				{
					uid: 'S002',
					sname: '预备费',
					levelType: 0,
					moneyOther: 0,
					costPrice: 0,
					children: []
				}
			]
		}
	},
	methods: {
		// 右侧表格点击保存
		doSave() {
			this.$refs.rightTable.doSave()
		},

		// 保存成功回调
		onSuccess() {
			this.getList()
			this.getPrepareList()
			this.getLeftTree()
		},

		// 项目结构新增回调
		onRefresh() {
			this.getLeftTree
		},

		// 右侧表格点击 锁定/解锁
		changeLock() {
			this.isLock = !this.isLock
			this.$refs.rightTable.doLock(this.isLock)
		},

		// 右侧表格 返回 造价文件列表
		doBack() {
            let _path = this.$route.path === '/projectAnalysis/estimate-price' ? '/projectAnalysis' : '/project-info'
			this.$router.push({
				// path: '/project-info',
				path: _path,
				query: this.$route.query
			})
		},

		// 左侧点击展示/隐藏
		changeLeftShow(status) {
			this.leftShow = status
		},

		// 获取项目结构数据
		getLeftTree() {
			this.mainCost = []
			getProjectBudgets({ projectId: this.curProjectId }).then(res => {
				if (res.code === 0) {
					if (res.data.projectTree) {
						res.data.projectTree.pid = 'S000'
						this.mainCost.push(res.data.projectTree)
					}
				}
			})
		},

		// 获取其他费用 数据
		getList() {
			this.otherCostData[0].children = []
			selectBudgetOtherList({
				projectId: this.curProjectId,
				costType: 1
			}).then(res => {
				if (res.code === 0) {
					let num = 0
					res.data.budgetOthers.forEach(x => {
						x.uid = x.id
						x.pid = 'S001'
						x.levelType = 2
						x.moneyOther = x.costPrice
						num += x.costPrice
					})
					this.otherCostData[0].costPrice = num
					this.otherCostData[0].moneyOther = num
					this.otherCostData[0].children.push(
						...res.data.budgetOthers
					)
				}
			})
		},

		// 获取预备费
		getPrepareList() {
			this.prepareCostData[0].children = []
			selectBudgetOtherList({
				projectId: this.curProjectId,
				costType: 2
			}).then(res => {
				if (res.code === 0) {
					res.data.budgetOthers.forEach(x => {
						x.uid = x.id
						x.pid = 'S002'
						x.levelType = 2
						x.moneyOther = x.costPrice
					})
					this.prepareCostData[0].children.push(
						...res.data.budgetOthers
					)
				}
			})
		},

		// 其他费用添加节点
		appendChild(data, children) {
			data.children.push(children)
		},

		// 其他费用删除节点
		removeNode(node, data) {
			// 执行
			if (data.id) {
				deleteOtherCost({ id: data.id }).then(res => {
					if (res.code === 0) {
						this.$refs.rightTable.doDelete(node, data)
						if (data.costType === 1) {
							this.$refs.otherCost.doRemove(node, data)
						} else {
							this.$refs.prepareCost.doRemove(node, data)
						}
					}
				})
			} else {
				this.$refs.rightTable.doDelete(node, data)
			}
		},

		// 费用编辑时触发
		changeVal(row, type) {
			let item
			if (type === 1) {
				item = this.otherCostData[0].children.find(
					x => x.uid === row.uid
				)
			} else {
				item = this.prepareCostData[0].children.find(
					x => x.uid === row.uid
				)
			}
			item.moneyOther = row.moneyOther
			item.costPrice = row.moneyOther
		}
	},
	created() {
		// 获取其他费用
		this.getLeftTree()
		this.getList()
		this.getPrepareList()
	},
	computed: {
		// 当前项目ID
		curProjectId() {
			return this.$route.query.projectId
		},
		// 文件类型
		filesList() {
			return [
				{ label: 'XML', value: '0' },
				{ label: 'EXCEL', value: '1' }
			]
		},
		// 动态左侧样式
		activeStyle() {
			if (!this.leftShow) {
				return {
					width: '50px'
				}
			}
			return { width: '360px' }
		}
	}
}
</script>
<style lang="less" scoped>
.estimate-price-layout {
	height: 100%;
	display: flex;
	background-color: #fff;

	.estimate-price-left {
		width: 360px;
		height: 100%;
		padding: 0 10px;
		overflow: auto;
		border-right: 1px solid #ccc;

		.baseForm-header {
			color: #07a2ea;
			overflow: hidden;
		}
	}

	.estimate-price-right {
		flex: 1;
		overflow: auto;
		.baseList-layout {
			position: relative;
			padding-top: 50px;
			height: 100%;
			.baseList-header {
				padding: 0 10px;
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 50px;
				line-height: 50px;
				background-color: #fff;
				display: flex;
				justify-content: flex-end;
				.btnGroups {
					float: right;
					display: flex;
					align-items: center;
					height: 100%;
					box-sizing: border-box;
				}
			}

			.baseList-content {
				padding: 0 10px;
				overflow-y: hidden;
				height: 100%;
			}
		}
	}
}
</style>